import * as types from "./actionTypes";
import securityApi from "../api/shared/securityApi";
import * as ajax from "./ajaxCounterActions";
import * as exception from "./exceptionActions";
import { showToastrError } from "../util/toastr";
import redirector from "../util/redirector";

export function getAuthorizationInfo() {
	return function (dispatch) {
		dispatch(ajax.started());
		return securityApi.getAuthorizationInfo()
			.then((response) => {
				dispatch(ajax.ended());
				dispatch(authorizationInfoLoaded(response.data));
			})
			.catch(error => {
				//todo refactor this
				dispatch(ajax.failed());
				if (error.response.status === 302) {
					redirector.goToPathInParentWindow(error.response.data);
				}
				else {
					showToastrError("No Authentication Header Info");
					dispatch(exception.throwException(error));
				}
			});
	};
}

function authorizationInfoLoaded(authorizationInfo) {
	return {
		type: types.AUTHORIZATION_INFO_LOADED,
		body: authorizationInfo
	};
}

export function setCurrentOrganisation(organisatie) {
	return {
		type: types.SET_CURRENT_ORGANISATION,
		body: { organisatie }
	};
}
